export default {
  path: '/priorities',
  name: 'priorities',
  component: () => import('../components/priority/Layout'),
  redirect: { name: 'PriorityList' },
  meta: {
    breadcrumb: 'priority.priorities',
  },
  children: [
    {
      name: 'PriorityList',
      path: '',
      component: () => import('../views/priority/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'PriorityCreate',
      path: 'new',
      component: () => import('../views/priority/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'PriorityUpdate',
      path: ':id/edit',
      component: () => import('../views/priority/Update'),
      meta: {
        breadcrumb: 'priority.priority',
      },
    },
    {
      name: 'PriorityShow',
      path: ':id',
      component: () => import('../views/priority/Show'),
      meta: {
        breadcrumb: 'priority.priority',
      },
    }
  ]
};
